import { getFoodieProgress, toggleVisited, toggleMustTry, completeQuest, incompleteQuest } from './foodieProgress.js';
import { openScannerModal, initScannerStyles } from './qr-scanner.js';
// import { checkAndAwardBadges } from './badges.js'; // DISABLED: Focusing on quests & must-try

const client = algoliasearch('KF4U0JJSKN', '211b5bfe85caf6fbf7d415b73eb1d860');
const index = client.initIndex('fogg_explore_random_sort');
const searchIndex = client.initIndex('fogg');

let questPlacesMap = {};   // questId -> [placeIds]

let page = 0;
let isLoading = false;
const hitsPerPage = 16;
let ggApp = null;
let scrollAttached = false;

function getGallery() {
  return document.getElementById('gallery');
}

function getList() {
  return document.getElementById('list-view');
}

function getLoading() {
  return document.getElementById('loading');  
}

function theEnd() {
  return document.getElementById('this-is-the-end');
}

function loadMore() {
  if (isLoading) return;
  isLoading = true;

  const gallery = getGallery();
  const loadingElem = getLoading();
  const endElem = theEnd();

  if (!gallery || !loadingElem) return;

  loadingElem.style.display = 'block';
  loadingElem.style.visibility = 'visible';
  loadingElem.style.opacity = '1';

  console.log('Starting loadMore...');

  index.search('', { page, hitsPerPage }).then(({ hits, nbPages }) => {
    console.log('Algolia hits received:', hits.length);
    
    const fragment = document.createDocumentFragment();
    const newItems = [];

    hits.forEach(hit => {
      const restaurant = document.createElement('div');
      restaurant.className = 'restaurant grid-item';

      const img = new Image();
      img.src = hit.field_hero_image;
      img.alt = hit.title;
      img.dataset.id = hit.id;
      img.className = 'explore-thumbnail';
      img.loading = 'lazy';
      img.decoding = 'async';

      const title = document.createElement('div');
      title.className = 'explore-title';
      title.textContent = hit.title;

      restaurant.appendChild(img);
      restaurant.appendChild(title);
      fragment.appendChild(restaurant);
      newItems.push(restaurant);

      const listItem = document.createElement('li');
      listItem.className = 'text-entry';
      listItem.textContent = hit.title;
      listItem.addEventListener('click', () => openEateryModal(hit.id));
      document.getElementById('list-view').appendChild(listItem);
    });

    // Append all at once to minimize layout shifts
    gallery.appendChild(fragment);

    // Wait only for new items' images to load (instead of all images)
    imagesLoaded(newItems, () => {
      const sentinel = document.getElementById('scroll-sentinel');
      
      if (!gallery.masonryInstance) {
        gallery.masonryInstance = new Masonry(gallery, {
          itemSelector: '.grid-item',
          columnWidth: '.grid-sizer',
          percentPosition: true,
        });
        console.log('📐 Masonry initialized');
      } else {
        gallery.masonryInstance.appended(newItems);
        gallery.masonryInstance.layout();
        // Force a slight delayed layout recalculation to fix stacking glitches
        setTimeout(() => gallery.masonryInstance.layout(), 100);
        console.log('🧱 Masonry layout triggered');
      }
    
      isLoading = false;
      loadingElem.style.display = 'none';
    
      if (hits.length < hitsPerPage) {
    
        if (sentinelObserver && sentinel) {
          sentinelObserver.unobserve(sentinel);
          sentinelObserver.disconnect();
          sentinelObserver = null;
        }
    
        endElem.style.display = 'block';
      }
    
      page++;
    });    
  }).catch(err => {
    console.error('Search error:', err);
    isLoading = false;
    loadingElem.style.display = 'none';
  });
}

function debounce(fn, delay = 150) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

function getScrollContainer() {
  return ggApp?.shadowRoot?.querySelector('main') || null;
}

let sentinelObserver = null;  // global or outer scope variable

function setupInfiniteScroll() {
  const gallery = document.getElementById('gallery');
  const sentinel = document.getElementById('scroll-sentinel');
  const scrollContainer = getScrollContainer();

  if (!gallery || !sentinel || !scrollContainer) {
    requestAnimationFrame(setupInfiniteScroll);
    return;
  }

  sentinelObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !isLoading) {
        loadMore();
      }
    });
  }, {
    root: scrollContainer,
    rootMargin: '300px',
    threshold: 0,
  });

  sentinelObserver.observe(sentinel);

  loadMore();
}

window.addEventListener('DOMContentLoaded', () => {
  ggApp = document.querySelector('gg-app');

  const gallery = getGallery();
  if (gallery) {
    gallery.addEventListener('click', (e) => {
      const img = e.target.closest('img.explore-thumbnail');
      if (img?.dataset?.id) {
        openEateryModal(img.dataset.id);
      }
    });
  }

  setupInfiniteScroll();
  
  // Initialize QR scanner styles
  initScannerStyles();
  
  // Set app session flag for check-in flow
  sessionStorage.setItem('fogg_session', 'active');
  
  // Check for ?open= parameter to auto-open modal
  const urlParams = new URLSearchParams(window.location.search);
  const openEateryId = urlParams.get('open');
  if (openEateryId) {
    console.log('Auto-opening eatery modal:', openEateryId);
    // Wait a bit for page to load before opening modal
    setTimeout(() => {
      openEateryModal(openEateryId);
    }, 500);
  }
});

/////////////////
// Search Input //
/////////////////
const searchWrapper = document.getElementById('explore-search');
const searchInput = document.getElementById('searchInput');
const suggestionsList = document.getElementById('searchSuggestions');
const cancelSearch = document.getElementById('cancelSearch');

const debouncedSearch = debounce((query) => {
  index.search(query).then(({ hits }) => {
    suggestionsList.innerHTML = '';
    if (hits.length === 0) {
      suggestionsList.style.display = 'none';
      return;
    }

    hits.forEach(hit => {
      const li = document.createElement('li');
      li.textContent = hit.title;
      li.className = 'suggestion-item';
      li.setAttribute('data-id', hit.id);
      li.setAttribute('role', 'option');
      li.setAttribute('aria-label', hit.title);

      li.addEventListener('click', () => {
        openEateryModal(hit.id);
        suggestionsList.style.display = 'none';
      });

      suggestionsList.appendChild(li);
    });

    suggestionsList.style.display = 'block';
  });
}, 200);

searchInput.addEventListener('input', function () {
  const query = this.value.trim();
  if (!query) {
    suggestionsList.style.display = 'none';
    return;
  }
  debouncedSearch(query);
});

function toggleCancelLink() {
  cancelSearch.style.display = searchInput.value.trim() !== '' ? 'inline' : 'none';
}

searchInput.addEventListener('focus', () => {
  searchWrapper.classList.add('expanded');
  window.scrollTo({ top: 0, behavior: 'smooth' });
  toggleCancelLink();
});

searchInput.addEventListener('blur', () => {
  setTimeout(() => {
    searchWrapper.classList.remove('expanded');
    suggestionsList.style.display = 'none';
  }, 200);
});

cancelSearch.addEventListener('click', (e) => {
  e.preventDefault();
  searchWrapper.classList.remove('expanded');
  searchInput.value = '';
  suggestionsList.innerHTML = '';
  toggleCancelLink();
});

searchInput.addEventListener('input', toggleCancelLink);
cancelSearch.style.display = 'none';

/* Toggle Buttons */
const toggleButtons = document.querySelectorAll('[data-view]');
const gallery = getGallery();
const listView = getList();

toggleButtons.forEach(button => {
  button.addEventListener('click', () => {
    const view = button.dataset.view;

    // Toggle active button state
    toggleButtons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');

    // Show/hide views
    if (view === 'grid') {
      gallery.style.display = 'block';
      listView.style.display = 'none';
      if (gallery?.masonryInstance) {
        setTimeout(() => {
          gallery.masonryInstance.layout();
          console.log('🔁 Masonry re-layout triggered on view toggle');
        }, 50);
      }
    } else if (view === 'list') {
      gallery.style.display = 'none';
      listView.style.display = 'block';
    }
  });
});


///////////////////////////////////////////////////
/// eatery modal - turn this into web component ///
///////////////////////////////////////////////////
const DRUPAL_API_BASE = window.location.hostname.includes('localhost')
  ? 'http://localhost:8888'
  : 'https://ggcity.org';


export async function openEateryModal(placeId) {
  try {
    const loadingElem = document.getElementById('loading');
    loadingElem.style.display = 'block';
    loadingElem.style.visibility = 'visible';
    loadingElem.style.opacity = '1';

    const res = await fetch(`${DRUPAL_API_BASE}/api/fogg/restaurant/${placeId}`);
    const data = await res.json();
    
    // Cache restaurant data for later use (profile page, etc.)
    try {
      const cacheKey = `restaurant_${placeId}`;
      localStorage.setItem(cacheKey, JSON.stringify({
        data,
        timestamp: Date.now()
      }));
    } catch (e) {
      console.warn('Failed to cache restaurant data', e);
    }

    const modal = document.getElementById('eatery-modal');
    if (!modal) return;

    const heroImg = modal.querySelector('.eatery-hero-img');
    heroImg.src = data.hero_image || '';
    heroImg.alt = data.title || 'Eatery photo';

    modal.querySelector('.eatery-modal-title').textContent = data.title || 'Untitled';
    modal.querySelector('.eatery-meta').innerHTML = `
      <span class="eatery-type">${data.type || 'N/A'}</span><br>
      <span class="eatery-address">${data.address || ''}</span>
    `;

    const gallery = modal.querySelector('.eatery-gallery');
    gallery.innerHTML = '';
    if (Array.isArray(data.images)) {
      data.images.forEach(url => {
        const img = document.createElement('img');
        img.src = url;
        img.alt = `${data.title} photo`;
        img.loading = 'lazy';
        img.className = 'eatery-image';
        gallery.appendChild(img);
      });
    }

    const checkinBtn = modal.querySelector('.checkin-btn');
    const visitedBtn = modal.querySelector('.visited-btn');
    const mustTryBtn = modal.querySelector('.must-try-btn');
    
    checkinBtn.dataset.placeId = placeId;
    visitedBtn.dataset.placeId = placeId;
    mustTryBtn.dataset.placeId = placeId;

    const { visited, mustTry } = await getFoodieProgress();
    const isVisited = visited.includes(placeId.toString());
    
    // Show correct button based on visited status
    if (isVisited) {
      checkinBtn.style.display = 'none';
      visitedBtn.style.display = 'inline-flex';
    } else {
      checkinBtn.style.display = 'inline-flex';
      visitedBtn.style.display = 'none';
    }
    
    mustTryBtn.classList.toggle('active', mustTry.includes(placeId.toString()));

    loadingElem.style.display = 'none';

    modal.classList.remove('hidden');
    document.body.classList.add('modal-open');

  } catch (err) {
    console.error('Error opening eatery modal:', err);
  }
}

// --- Wire up modal toggle buttons ---
document.addEventListener('click', async (e) => {
  // Check In button - opens QR scanner
  const checkinBtn = e.target.closest('.checkin-btn');
  if (checkinBtn) {
    console.log('Opening QR scanner for check-in...');
    openScannerModal();
    return;
  }

  // Visited button - no action (just shows status)
  const visitedBtn = e.target.closest('.visited-btn');
  if (visitedBtn) {
    console.log('Already visited this eatery');
    return;
  }

  // Must-try button - toggles must-try status
  const mustTryBtn = e.target.closest('.must-try-btn');
  if (mustTryBtn) {
    const placeId = mustTryBtn.dataset.placeId;
    const updatedMustTry = await toggleMustTry(placeId);
    mustTryBtn.classList.toggle('active', updatedMustTry.includes(placeId));
    document.dispatchEvent(new CustomEvent('mustTryUpdated', { detail: { list: updatedMustTry } }));
    return;
  }
});

// Back button closes eatery modal
document.querySelector('.back-button').addEventListener('click', () => {
  document.getElementById('eatery-modal').classList.add('hidden');
  document.body.classList.remove('modal-open');
  updateAllQuestProgress();
    
});

// ✅ --- Optimized quest completion checker ---
async function checkQuestCompletionAfterVisited(placeId) {
  const { visited } = await getFoodieProgress(); // ✅ always fresh
  const placeStr = placeId.toString();

  // Find which quests contain this place
  const affectedQuests = Object.entries(questPlacesMap)
    .filter(([questId, placeIds]) => placeIds.includes(placeStr));

  if (!affectedQuests.length) {
    console.log("No quests affected by this place.");
    return;
  }

  for (const [questId, placeIds] of affectedQuests) {
    const total = placeIds.length;
    const done = placeIds.filter(id => visited.includes(id)).length;

    console.log(`Quest ${questId}: ${done}/${total}`);

    if (done === total && total > 0) {
      console.log(`🎉 Quest ${questId} fully completed from eatery modal!`);

      // Persist quest completion
      await completeQuest(questId);

      // Update quest card UI
      await updateQuestCompletionUI();

      // 🎊 Confetti feedback
      launchConfetti();
    }
    else {
      console.log(`Calling incomplete on Quest ${questId}`);
      await incompleteQuest(questId);
    }  
  }
}

// --- Update quest progress for all cards ---
async function updateAllQuestProgress() {
  const progressEls = document.querySelectorAll('.quest-progress');
  const { visited, mustTry, quests: completedQuests = [] } = await getFoodieProgress();
  const visitedSet = new Set(visited);
  const completedSet = new Set(completedQuests.map(q => q.toString()));

  for (const el of progressEls) {
    const questId = el.getAttribute('data-id');
    let total = 0;
    let done = 0;

    try {
      if (questPlacesMap[questId]) {
        const placeIds = questPlacesMap[questId];
        total = placeIds.length;
        done = placeIds.filter(id => visitedSet.has(id)).length;
      } else {
        const res = await fetch(`${DRUPAL_API_BASE}/api/fogg/foodie-quests/${questId}`);
        const places = await res.json();

        if (!Array.isArray(places)) {
          el.textContent = 'Error loading';
          continue;
        }

        total = places.length;
        done = places.filter(p => visitedSet.has(p.id.toString())).length;
      }

      // Update progress bar UI
      const fill = el.querySelector('.progress-bar-fill');
      const text = el.querySelector('.progress-bar-text');

      if (fill && text) {
        const percentage = total > 0 ? (done / total) * 100 : 0;
        fill.style.width = percentage + '%';
        text.textContent = `Visited ${done} of ${total}`;

        if (percentage === 100) {
          fill.classList.add('full');
        } else {
          fill.classList.remove('full');
        }
      } else {
        // fallback to text only
        el.textContent = `Visited ${done} of ${total}`;
      }

      // Auto-complete quests that are fully visited but not marked completed
      if (total > 0 && done === total && !completedSet.has(questId)) {
        console.log(`⚡ Auto-marking quest ${questId} as completed (visited all)`);
        await completeQuest(questId);
      }

    } catch (err) {
      console.error(`Error fetching progress for quest ${questId}:`, err);
      el.textContent = 'Error loading';
    }
  }
}

// ✅ --- Fullscreen Lightbox ---
function setupLightbox() {
  const overlay = document.getElementById('lightbox-overlay');
  const overlayImg = document.getElementById('lightbox-img');
  const closeBtn = document.querySelector('.lightbox-close');

  document.body.addEventListener('click', (e) => {
    console.log('image click');
    const img = e.target.closest('.eatery-image');
    if (!img) return;
    overlayImg.src = img.src;
    overlayImg.alt = img.alt || 'Full view';
    overlay.classList.remove('hidden');
  });

  closeBtn.addEventListener('click', () => {
    overlay.classList.add('hidden');
    overlayImg.src = '';
  });

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      overlay.classList.add('hidden');
      overlayImg.src = '';
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !overlay.classList.contains('hidden')) {
      overlay.classList.add('hidden');
      overlayImg.src = '';
    }
  });
}

setupLightbox();
